module.exports = __webpack_public_path__ + "assets/img/5ff97a18cb227bd576823bb15a4ad9ba.svg";